import api from '../config/api';
import { dataConfigType, getDataConfigType } from './test/data-config';
import { testdataRange1, testdataRange2, getTestData } from './test/engagement-okrs-data';
import moment from 'moment';
import { jsToUnixDate, unixToJSDate } from '../components/ChartOKRs/components/LineChart/utils';

export async function get(id, timeframe) {
  const currentDataConfigType = getDataConfigType();
  const getDataSetId = () => Math.floor((Math.random() * 10000) + 1);

  switch (currentDataConfigType) {
    case dataConfigType.LIVEDATA: {
      const startDate = jsToUnixDate(timeframe.start), endDate = jsToUnixDate(timeframe.end);
      const url = `${wbConfig.baseUrl}/restapi/engagementReport/teamEngagementOverTime/?startDate=${startDate}&endDate=${endDate}&userId=${id}`;
      const { data: { data = [] } = [] } = await api.get(url);

      // TODO: This is a temporary hack to remove 1st data point which is invalid
      if (data) {
        data.okrs[0].series.data.shift();
        data.okrs[1].series.data.shift();
      }

      return data;
    }
    case dataConfigType.TESTDATA1:
    case dataConfigType.TESTDATA2: {
      const data = getTestData(currentDataConfigType), dataSetId = getDataSetId();
      data.okrs[0].id = dataSetId;
      data.okrs[1].id = dataSetId + 1;
      return new Promise(ok => {
        setTimeout(() => {
          ok(() => {
            console.log(`teamEngagementOverTime (${(currentDataConfigType === dataConfigType.TESTDATA1) ? 'TESTDATA1' : 'TESTDATA2'})`, id, data);
            return id === 1 ? data : [];
          });
        }, 1500);
      });
    }
    default: return undefined;
  }
}

export async function getCurrentQuarter(id) {
  let currentQuarter = {};
  let currentDataConfigType = getDataConfigType();
  switch (currentDataConfigType) {
    case dataConfigType.LIVEDATA:
      const { data: { filterComp = [] } = [] } = await api.get(
        `${wbConfig.baseUrl}/goal/okrFilterComp?fromFilter=1`
      );
      [ currentQuarter ] = filterComp.filter(d => d.period && d._isCurrent == true);
      if (!currentQuarter) {
        console.error('okrFilterComp current quarter not found');
        return {};
      }

      /*
      // Dev only: Set start & end to match retrieved data
      const ADJUST_DATES = false;
      if (ADJUST_DATES) {
        currentQuarter.format = 'MM/DD/YYYY'; // TODO.
        currentQuarter.start = moment(
          unixToJSDate(
            currentDataConfigType === dataConfigType.TESTDATA1
              ? testdataRange1.START
              : testdataRange2.START
          )
        ).format(currentQuarter.format);
        currentQuarter.end = moment(
          unixToJSDate(
            currentDataConfigType === dataConfigType.TESTDATA1
              ? testdataRange1.END
              : testdataRange2.END
          )
        ).format(currentQuarter.format);
        currentQuarter.period = 1;
        currentQuarter.name = 'Q1 2021';
        console.log('adjusted dates (live data)', currentQuarter.start, currentQuarter.end);
      }
      */
      break;

    case dataConfigType.TESTDATA1:
    case dataConfigType.TESTDATA2:
      currentQuarter.format = 'MM/DD/YYYY'; // TODO.
      currentQuarter.start = moment(
        unixToJSDate(
          (currentDataConfigType === dataConfigType.TESTDATA1)
            ? testdataRange1.START
            : testdataRange2.START)).format(currentQuarter.format);
      currentQuarter.end = moment(
        unixToJSDate(
          (currentDataConfigType === dataConfigType.TESTDATA1)
          ? testdataRange1.END
          : testdataRange2.END)).format(currentQuarter.format);
      console.log('currentQuarter (test data)', currentQuarter);
      break;
  }
  return currentQuarter;
}

export default {
  get,
  getCurrentQuarter
};
